import { AddCircleOutline } from "@mui/icons-material";
import { Box, Button, Container, Grid, Typography, useTheme } from "@mui/material";
import { clip, useMediaQuery } from "../utilities/index.js";
import { ModalSheet, ModalSheetTitle } from "../modal/index.js";
import { ProductContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import React from "react";
export const DescriptionModal = NiceModal.create(({ title, description }) => {
    const { t } = useTranslation("c-product");
    const modal = useModal();
    return (React.createElement(ModalSheet, { label: title, open: modal.visible, onClose: modal.hide },
        React.createElement(ModalSheetTitle, null, t("background-headline", "Die Geschichte")),
        React.createElement(Typography, { component: "div", dangerouslySetInnerHTML: { __html: description }, paragraph: true, sx: { "& > p": { mb: 3, maxWidth: "70ch" } }, variant: "body1" }),
        React.createElement(Button, { fullWidth: true, variant: "outlined", size: "small", onClick: modal.hide, sx: { mt: 1 } }, t("close", "Schließen"))));
});
//TODO not sure how to properly insert props, as it would be 3 severall ones
export const ProductDescription = () => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const { description, primaryCharacter, title } = React.useContext(ProductContext);
    const truncatedDescription = clip(description, 300, { html: true, indicator: " …" });
    const openDescriptionModal = () => NiceModal.show(DescriptionModal, { title, description });
    const useColumnLayout = useMediaQuery(theme.breakpoints.up("md"));
    const isAtLeastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const truncate = useMediaQuery(theme.breakpoints.down("sm"));
    if (useColumnLayout) {
        return (React.createElement(Container, { component: "section", maxWidth: "xl", sx: { pt: 14, pb: 0 } },
            React.createElement(Grid, { container: true, alignItems: "flex-end", spacing: { xs: 0, lg: 0 } },
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 6 },
                    React.createElement(Typography, { variant: "h2", sx: { pt: 0, pb: 6 } }, t("background-headline", "Die Geschichte")),
                    React.createElement(Typography, { component: "div", dangerouslySetInnerHTML: { __html: description }, paragraph: true, sx: { "& > p": { mb: 3 }, pb: 6 }, variant: "body1" })),
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 6 },
                    React.createElement(Box, { sx: {
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: { xs: "center", lg: "flex-start" },
                            img: isAtLeastLg
                                ? {}
                                : {
                                    maxWidth: "40vw",
                                    height: "auto",
                                },
                        } },
                        React.createElement(Image, { alt: t("character-from-game-x", "Figur aus dem Krimidinner {{title}}", { title }), style: {
                                display: "flex",
                                transformOrigin: "bottom left",
                                transform: "scale(1.05) translateX(5%)",
                            }, ...primaryCharacter, placeholder: "empty" }))))));
    }
    else {
        return (React.createElement(Container, { component: "section", maxWidth: "xl", sx: { backgroundColor: theme.palette.grey[50], pb: 5, pt: 8 } },
            React.createElement(Typography, { variant: "h2", sx: { pt: 0, pb: 3, hyphens: "none" } }, t("background-headline", "Die Geschichte")),
            React.createElement(Typography, { component: "div", dangerouslySetInnerHTML: { __html: truncate ? truncatedDescription : description }, paragraph: true, sx: { "& > p": { mb: 3, maxWidth: "70ch" } }, variant: "body1" }),
            truncate && (React.createElement(Box, { sx: { display: "flex", justifyContent: "center", py: 1.5 } },
                React.createElement(AddCircleOutline, { onClick: openDescriptionModal, sx: { color: theme.palette.text.primary } })))));
    }
};
//# sourceMappingURL=description.js.map